import * as React from "react";

import ExtendedHeadings from "../../elements/ExtendedHeadings/ExtendedHeadings";
import { Paragraph } from "@mindarc/arctheme-components/frontend/src/stories/components/elements/Paragraph/Paragraph";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import { mobileBreakpoint } from "../../../../entrypoints/theme";

export const Title = ({ settings }) => {
  const isMobile = useMobileBreakpoint(mobileBreakpoint);

  const renderComponents = () => {
    return (
      <div
        className={`block-title mt-[${settings.block_settings.margin_top_mobile}px] 
        lg:mt-[${settings.block_settings.margin_top_desktop}px] 
        mb-[${settings.block_settings.margin_bottom_mobile}px] 
        lg:mb-[${settings.block_settings.margin_bottom_desktop}px] 
        text-${settings.section_settings.content_alignment_mobile} 
        lg:text-${settings.section_settings.content_alignment_desktop}`}
      >
        {isMobile ? (
          <Paragraph
            text={settings.block_settings.title}
            type={"text-[28px]/9 font-body font-semibold text-primary"}
          />
        ) : (
          <ExtendedHeadings
            text={settings.block_settings.title}
            classes="h2 !text-[28px]/9 font-semibold text-primary lg:!text-[32px]/9"
          />
        )}
      </div>
    );
  };

  if (settings.block_settings.render_type !== "all") {
    if (isMobile && settings.block_settings.render_type !== "mobile-only")
      return;
    if (!isMobile && settings.block_settings.render_type !== "desktop-only")
      return;
  }

  return <>{renderComponents()}</>;
};

export default Title;
